export default __webpack_public_path__ + "static/media/gallery_02.600d5e39.jpg";